define('app/controllers/liquidacions',['angular', 'app/services/shared'], function(angular) {
  var module = angular.module('app.liquidacions', ['app.shared']);

  module.factory('liquidacionsService', ['$http', '$mdDialog', '$q', '$injector', '$location','sharedProperties', 'globalService', function ($http, $mdDialog, $q, $injector, $location, sharedProperties, globalService) {

    var serveis = {
      consumeAction: function(action, id, elem, routeParams) {
        var api_base_url = sharedProperties.getApiBaseUrl();
        var deferred = $q.defer();

        if (action.internalAction == 'generarLiquidacions') {
          var getMontYear = $mdDialog.prompt()
            .title('De quin mes vols generar les liquidacions?')
            .textContent('Entra el mes i l\'any')
            .placeholder('MM/YYYY')
            .ariaLabel('Mes i any')
            //.initialValue('01/2016')
            //.targetEvent(event)
            .ok('Genera-ho!')
            .cancel('Ups... encara no!');
          $mdDialog.show(getMontYear).then(function(result){
            var re = new RegExp("([0-9]{1,2})/?([0-9]{4})");
            var res = re.exec(result);
            if (res == null) {
              var alert = $mdDialog.alert({
                title: 'Ups... I did it again!',
                textContent: 'El valor "' + result + '" es incorrecte, ha de tenir el format: MM/YYYY',
                ok: 'D\'acord'
              });

              $mdDialog.show( alert ).finally(function() {
                alert = undefined;
                action.active = true;
                deferred.resolve({ processed: true, elem: null, responses: null, error: null });
              });
            }
            else {
              $http.post(api_base_url + 'liquidacions/generate/all', {Mes: parseInt(res[1]), Any: parseInt(res[2])}).then(function (response) {
                action.active = true;
                deferred.resolve({processed: true, elem: null, responses: null, error: null, refresh: true})
              }, function errorCallback(response) {
                action.active = true;
                deferred.reject(response);
              });
            }
          }, function() {
            action.active = true;
            deferred.resolve({processed: true, elem: null, responses: null, error: null, refresh: false})
          });
        }
        else {
          //console.log('continue to globalService');
          return globalService.consumeAction(action, id, elem, routeParams)
        }
        return deferred.promise;
      }
    };
    return serveis;
  }]);

  module.controller('LiquidacioEditController', [
    '$scope',
    '$http',
    '$route',
    '$location',
    '$filter',
    'sharedProperties',
    'actionFactory',
    'consumer',
    'state',
    'info',
    'elem',
	'elems',
	'extrainfo',
    function($scope, $http, $route, $location, $filter, sharedProperties, actionFactory, consumer, state, info, elem, elems, extrainfo) {
      $scope.elemId = info.isInt ? parseInt($route.current.params.id):$route.current.params.id;
      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elem = elem;
	  $scope.elems = elems;
	  $scope.extrainfo = extrainfo;

      actionFactory.complementActions(info, $scope.actions, $scope.elemId);

      var rebuts = info.allData["rebuts"];
      $scope.actionsRebuts = rebuts.states.browse.elemActions;
      $scope.rebuts = rebuts;
      $scope.queryRebuts = {order:"Order"};

      var theIds = [];
      angular.forEach(elem.Rebuts, function(value, key) {
        this.push(value.Id);
      }, theIds);
      actionFactory.complementActions(rebuts, $scope.actionsRebuts, theIds);

      var pagaments = info.allData["pagaments"];
      $scope.actionsPagaments = pagaments.states.browse.elemActions;
      $scope.pagaments = pagaments;
      $scope.queryPagaments = {order:"Order"};

      var theIds2 = [];
      angular.forEach(elem.Pagaments, function(value, key) {
        this.push(value.Id);
      }, theIds2);
      actionFactory.complementActions(pagaments, $scope.actionsPagaments, theIds2);

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;
        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          console.log(retVal);
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.elem = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason)
        }, function (update) {
          console.log('Got notification', update)
        })
      })
    }
  ]);

  return module;
});

